export const getValidBidAmount = (bid: number, increment: number) => {
  if (bid < 0) {
    return increment;
  } else {
    return Math.ceil(bid / increment) * increment;
  }
};
